import http from './../../../base/api/public'
import {requestPostFile, requestPutFile} from '@/common/fileUtil.js'

let service = require('@/../config/serviceList')
let sysConfig = require('@/../config/sysConfig')
let apiPre = sysConfig.apiPre
export default {
  getPage(params) {
    return http.requestPost(apiPre + service.res + '/res/handProfit/getHandProfits', params)
  },
  delete(params) {
    return http.requestDelete(apiPre + service.res + '/res/handProfit/deleteHandProfit/' + params, {})
  },
  insert(params) {
    return http.requestPut(apiPre + service.res + '/res/handProfit/saveOrUpdateHandProfit', params)
  },
  getReportRecordColumns() {
    return http.requestQuickGet(apiPre+service.res + '/res/handProfit/reportColumns')
  },
  recordReport(params) {
    return http.requestDownloadExcel(apiPre + service.res + '/res/handProfit/excel', params)
  }
}



// WEBPACK FOOTER //
// ./src/module/resourceCenter/api/handProfit.js